import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';
import { BystSharedModule } from '@app/shared/byst-shared.module';
import { BlFrontendTextInputComponent } from 'src/app/core/wrappers/bl-frontend-text-input.component';
import { BlFrontendTextAreaComponent } from 'src/app/core/wrappers/bl-frontend-textarea.component';
import { ClientFormGroup, ClientGuideForm } from '../new-client-guide.types';

@Component({
  selector: 'app-step2-business-details',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    BlFrontendTextInputComponent,
    BlFrontendTextAreaComponent,
    BystSharedModule,
    ReactiveFormsModule,
  ],
  template: `
    <ng-container [formGroup]="form">
      <div class="flex flex-col">
        <bl-frontend-text-input text="Bransch" formControlName="businessArea"></bl-frontend-text-input>
      </div>
      <div class="flex flex-col mt-3">
        <app-calendar
          formControlName="registrationDate"
          appendTo="body"
          label="Registreringsdatum"
          [defaultDate]="null"
          [minSelectableDate]="null"
          class="flex flex-col">
        </app-calendar>
      </div>
      <div class="flex flex-col mt-3">
        <bl-frontend-textarea text="Beskrivning av verksamheten" formControlName="description"></bl-frontend-textarea>
      </div>
    </ng-container>
  `,
})
export class Step2BusinessDetailsComponent implements OnInit {
  @Input() formGroupName: keyof ClientGuideForm;

  form: FormGroup<ClientFormGroup>;

  // eslint-disable-next-line no-useless-constructor
  constructor(private rootFormGroup: FormGroupDirective) {}

  ngOnInit(): void {
    this.form = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
  }
}
